import React, { Component } from 'react';
import ContactUs from './contactUs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as AccontAction from '../accounts/accountActions';

class ContactUsForm extends Component {

	handleSubmit(values,resetForm) {
		const { accountActions,isLoading } = this.props;
		accountActions.onSendMessage(values);
		if(!isLoading){
			resetForm();
		}
		
	  }
	

	render() {
		const { isLoading } = this.props;
        return (
        <ContactUs
            onSubmit={this.onSubmit}
			isLoading={isLoading}
			handleSubmitBtn={(values,resetForm) => this.handleSubmit(values,resetForm)}
        />
		);
	}
}


const mapStateToProps = ({ userAccount }) => {
	const { isLoading } = userAccount;
	return {
	  isLoading,
	};
  };
  


const mapDispatchToProps = (dispatch) => {
	return {
		accountActions: bindActionCreators(AccontAction, dispatch),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContactUsForm));